/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus, form);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : '.enj-add-to-cart-btn',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    if (!settings.disableAjaxCart) {
      formOverride();
    }

    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    var count = cart ? cart.item_count : 0;
    $('.enj-cartcount').html(count);
    $('.js-number-cart').html(count);
    if (count === 0) {
      $('.enj-cartcount').addClass('hidden-count');
      $('.js-number-cart').removeClass('active');
    } else {
      $('.enj-cartcount').removeClass('hidden-count');
      $('.js-number-cart').addClass('active');
    }
    $('.product-popup').find('.product-item-count').html(count);
    if ($cartCostSelector && cart) {
      var moneyFmtHeader = (typeof settings !== 'undefined' && settings.moneyFormat) ? settings.moneyFormat : window.money_format;
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, moneyFmtHeader));
    }
  };

  function cartButtonLabels() {
    return window.florenza_cart_labels || {};
  }

  function rememberCartButtonLabel($btn) {
    $btn.each(function () {
      if (this.getAttribute('data-original-label') == null) {
        this.setAttribute('data-original-html', this.innerHTML);
        this.setAttribute('data-original-label', (this.textContent || '').replace(/\s+/g, ' ').trim());
      }
    });
  }

  function restoreCartButton($btn) {
    $btn.each(function () {
      if (this._florenzaRestoreTimer) {
        clearTimeout(this._florenzaRestoreTimer);
        this._florenzaRestoreTimer = null;
      }
      var html = this.getAttribute('data-original-html');
      if (html != null) this.innerHTML = html;
      this.classList.remove('is-adding', 'is-added');
      this.disabled = false;
      this.removeAttribute('aria-busy');
      if (typeof this.blur === 'function') this.blur();
    });
  }

  function markCartButtonAdding($btn) {
    var labels = cartButtonLabels();
    rememberCartButtonLabel($btn);
    $btn.each(function () {
      if (this._florenzaRestoreTimer) {
        clearTimeout(this._florenzaRestoreTimer);
        this._florenzaRestoreTimer = null;
      }
      this.classList.remove('is-added');
      this.classList.add('is-adding');
      this.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.textContent = labels.adding || this.getAttribute('data-original-label') || this.textContent;
    });
  }

  function markCartButtonAdded($btn) {
    var labels = cartButtonLabels();
    $btn.each(function () {
      var btn = this;
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'false');
      btn.textContent = labels.added || btn.getAttribute('data-original-label') || btn.textContent;
      if (typeof btn.blur === 'function') btn.blur();
      if (btn._florenzaRestoreTimer) clearTimeout(btn._florenzaRestoreTimer);
      btn._florenzaRestoreTimer = setTimeout(function () {
        restoreCartButton($(btn));
      }, 2000);
    });
  }

  formOverride = function () {
    $body.off('submit.ajaxcart', 'form[action*="/cart/add"]').on('submit.ajaxcart', 'form[action*="/cart/add"]', function(evt) {
      evt.preventDefault();
      var form = evt.target;
      var $addToCart_btn = $(form).find(settings.addToCartSelector);
      markCartButtonAdding($addToCart_btn);

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(form, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product, form) {
    var $headerBadge = $('.js-number-cart');
    var $cartCount = $('.enj-cartcount');
    var current = parseInt($headerBadge.text() || $cartCount.text(), 10) || 0;
    var next = current + (product.quantity || 1);
    $headerBadge.html(next).addClass('active');
    $cartCount.html(next);

    ShopifyAPI.getCart(cartUpdateCallback);
    $(document).trigger('cart:item-added', [product]);

    // Popup e botão só depois da atualização do carrinho (evita o popup bloquear o minicart)
    setTimeout(function() {
      var $addToCart_btn = $(form).find(settings.addToCartSelector);
      markCartButtonAdded($addToCart_btn);

      try {
        var moneyFmtPopup = (typeof settings !== 'undefined' && settings.moneyFormat) ? settings.moneyFormat : window.money_format;
        $('.product-popup').find('.product-name').html(product.title);
        $('.product-popup').find('.product-price').html(Shopify.formatMoney(product.price, moneyFmtPopup));
        $('.product-popup').find('.product-qty').html(product.quantity);
        $('.product-popup').find('.product-total').html(Shopify.formatMoney(product.line_price, moneyFmtPopup));
        $('.product-popup').find('.product-image img').attr('src', product.image);
        if (typeof showPopup === 'function') {
          showPopup('.product-popup');
        }
      } catch (e) {}
    }, 0);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus, form) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    var $btn = form ? $(form).find(settings.addToCartSelector) : $addToCart;
    restoreCartButton($btn);

    if (!!data.message) {
      if (data.status == 422) {
        var $errorForm = form ? $(form) : $formContainer;
        $errorForm.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  function renderMinicartInline(cart) {
    try {
      var $container = $('.enj-minicart-ajax');
      if (!$container.length) return;
      var moneyFmt = (typeof settings !== 'undefined' && settings.moneyFormat) ? settings.moneyFormat : (typeof window !== 'undefined' && window.money_format) ? window.money_format : '';
    var formatMoney = function(cents) {
      return typeof Shopify !== 'undefined' && Shopify.formatMoney ? Shopify.formatMoney(cents, moneyFmt) : (cents / 100).toFixed(2);
    };
    var getImgUrl = function(url) {
      if (!url) return '//cdn.shopify.com/s/assets/no-image-50.png';
      return (url + '').replace(/(\.[^.]*)$/, '_small$1').replace('http:', '');
    };
    var decodeHtml = function(t) {
      if (!t) return '';
      var el = document.createElement('textarea');
      el.innerHTML = String(t);
      return el.value;
    };
    var esc = function(t) {
      if (!t) return '';
      t = decodeHtml(t);
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    };
    var t = window.minicart_translations || {};
    var emptyHtml = '<div class="list_product_minicart empty"><div class="empty-product_minicart"><p class="mb-0">' + (t.empty || 'Sua sacola está vazia') + '</p><a href="/collections/all" class="to-cart">' + (t.shop_now || 'Ir para a loja') + '</a></div></div>';
    if (!cart || cart.item_count === 0) {
      $container.html(emptyHtml);
      return;
    }
    var itemsHtml = '';
    $.each(cart.items, function(i, item) {
      var img = item.image ? getImgUrl(item.image) : '//cdn.shopify.com/s/assets/no-image-50.png';
      var price = formatMoney(item.price);
      itemsHtml += '<cart-item class="minicart_item cart-drawer__item d-flex list-unstyled mb-0 px-0" data-line="' + (i + 1) + '" data-key="' + esc(item.key || '') + '" data-variant-id="' + item.variant_id + '">' +
        '<div class="thumb_img_cartmini cart-item__media"><a href="' + esc(item.url) + '" title="' + esc(item.title) + '" class="cart-item__link">' +
        '<img class="cart-item__image" alt="' + esc(item.title) + '" src="' + img + '" loading="lazy" width="80" height="80"></a></div>' +
        '<div class="product-detail cart-item__details"><p class="product_name_mini cart-item__name"><a href="' + esc(item.url) + '">' + esc(item.title) + '</a></p>' +
        '<div class="product_info cart-item__info"><div class="product_quanity cart-item__quantity">' +
        '<div class="minicart-qty-control" data-line="' + (i + 1) + '">' +
        '<button type="button" class="minicart-qty-btn minicart-qty-minus" data-line="' + (i + 1) + '" aria-label="Diminuir quantidade">&#8722;</button>' +
        '<input type="number" class="minicart-qty-input" data-line="' + (i + 1) + '" value="' + item.quantity + '" min="0" aria-label="Quantidade">' +
        '<button type="button" class="minicart-qty-btn minicart-qty-plus" data-line="' + (i + 1) + '" aria-label="Aumentar quantidade">&#43;</button>' +
        '</div></div>' +
        '<div class="product_price cart-item__price"><span class="price_sale">' + price + '</span></div></div></div>' +
        '<div class="produc_remove cart-item__remove"><a href="javascript:void(0)" class="remove-product" data-line="' + (i + 1) + '" data-variant-id="' + item.variant_id + '" aria-label="Remover item">' +
        '<i class="fa fa-trash-o" aria-hidden="true"></i></a></div></cart-item>';
    });
    var totalPrice = formatMoney(cart.total_price);
    var totalLabel = t.total_price || 'Total:';
    var viewCart = t.view_cart || 'Ver sacola';
    var checkout = t.checkout || 'Finalizar compra';
    var isRtl = $('body').hasClass('rtl');
    var html = '<div class="prod"><cart-drawer-items class="product-cart cart-drawer-items">' +
      '<form method="post" action="/cart" id="cart-drawer-form" class="cart-drawer-form" accept-charset="UTF-8">' +
      '<input type="hidden" name="form_type" value="cart"><input type="hidden" name="utf8" value="✓">' + itemsHtml + '</form></cart-drawer-items></div>' +
      '<div class="sub-total">' + (isRtl ? '<span class="total-title float-right">' + totalLabel + '</span><span class="total-price float-left">' + totalPrice + '</span>' : '<span class="total-title float-left">' + totalLabel + '</span><span class="total-price float-right">' + totalPrice + '</span>') + '</div>' +
      '<div class="action-checkout">' + (isRtl ? '<a href="/checkout" class="button-checkout"><span>' + checkout + '</span></a><a href="/cart" class="button-viewcart"><span>' + viewCart + '</span></a>' : '<a href="/cart" class="button-viewcart"><span>' + viewCart + '</span></a><a href="/checkout" class="button-checkout"><span>' + checkout + '</span></a>') + '</div>';
      $container.html(html);
    } catch (e) {
      if (typeof console !== 'undefined' && console.warn) console.warn('renderMinicartInline:', e);
    }
  }

  cartUpdateCallback = function (cart) {
    updateCountPrice(cart);

    if ($("#CartTemplate").length > 0) {
      buildCart(cart);
    }

    renderMinicartInline(cart);

    if (window.MinicartUpdate && typeof window.MinicartUpdate.updateMinicart === 'function') {
      window.MinicartUpdate.updateMinicart(cart);
    }
    $(document).trigger('cart:updated', [cart]);
  };

  buildCart = function (cart) {
    // Check if CartTemplate exists (only on cart page, not in minicart)
    if ($("#CartTemplate").length === 0) {
      console.log('CartTemplate not found, skipping buildCart');
      return;
    }

    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
      .append('<p>' + "Sua sacola está vazia" + '</p>');
      cartCallback(cart);
      return;
      $('.js-number-cart').removeClass('active');
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, (typeof settings !== 'undefined' && settings.moneyFormat) ? settings.moneyFormat : window.money_format),
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, (typeof settings !== 'undefined' && settings.moneyFormat) ? settings.moneyFormat : window.money_format)
    }
    $('.product-popup').find('.product-total-cart').html(Shopify.formatMoney(cart.total_price, (typeof settings !== 'undefined' && settings.moneyFormat) ? settings.moneyFormat : window.money_format));

    $cartContainer.append(template(data));

    cartCallback(cart);
    $('.js-number-cart').addClass('active');
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Minicart quantity: botão -
    $body.on('click', '.minicart-qty-minus', function(e) {
      e.preventDefault();
      var $btn = $(this);
      var line = parseInt($btn.data('line'), 10);
      var $input = $btn.siblings('.minicart-qty-input');
      var qty = parseInt($input.val(), 10) || 1;
      qty = qty - 1;
      if (qty < 0) qty = 0;
      $input.val(qty);
      updateQuantity(line, qty);
    });

    // Minicart quantity: botão +
    $body.on('click', '.minicart-qty-plus', function(e) {
      e.preventDefault();
      var $btn = $(this);
      var line = parseInt($btn.data('line'), 10);
      var $input = $btn.siblings('.minicart-qty-input');
      var qty = parseInt($input.val(), 10) || 0;
      qty = qty + 1;
      $input.val(qty);
      updateQuantity(line, qty);
    });

    // Minicart quantity: input manual (ao perder foco ou pressionar Enter)
    $body.on('change blur', '.minicart-qty-input', function(e) {
      var $input = $(this);
      var line = parseInt($input.data('line'), 10);
      var qty = parseInt($input.val(), 10);
      if (isNaN(qty) || qty < 0) { qty = 0; $input.val(0); }
      updateQuantity(line, qty);
    });

    $body.on('click', '.remove-product', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      var $el = $(this),
          line = $el.data('line'),
          qty = 0;
      
      // Prevent double clicks
      if ($el.hasClass('is-removing')) {
        console.log('Already removing, ignoring click');
        return false;
      }
      
      $el.addClass('is-removing');
      console.log('Removing item at line:', line);
      
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
      
      return false;
    })

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      if (isUpdating) {
        console.log('Update already in progress, skipping...');
        return;
      }
      
      isUpdating = true;
      console.log('updateQuantity called - line:', line, 'qty:', qty);

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Remove loading states
    $('.remove-product').removeClass('is-removing');

    // Trigger custom event for minicart update
    // This will handle the minicart rendering via minicart-update.js
    $(document).trigger('cart:updated', [cart]);

    // Only call buildCart if we're on the /cart page (not in minicart)
    // buildCart uses Handlebars and is for the cart page template
    if (window.location.pathname === '/cart') {
      setTimeout(function() {
        ShopifyAPI.getCart(buildCart);
      }, 150);
    }
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    // Exclude .minicart-qty-input — those are handled separately by adjustCart()
    var numInputs = $('input[type="number"]:not(.minicart-qty-input)');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
          console.log(qty);
          updatePricingQty(qty);
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
          updatePricingQty(qty);
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
